module.exports = __webpack_public_path__ + "static/img/02.47619b2b.jpg";